import { useState } from "react";
import instance from "../../index";
import { PagedList } from "../../../models/paged-list";
import { BaseResponse } from "../../../models/base-response";
import { RouteDto } from "../../../models/requests/route-dto";
import { RouteFilter } from "../../../models/requests/route-filter";
import { CreateRouteCommand } from "../../../models/requests/create-route-command";
import { UpdateRouteCommand } from "../../../models/requests/update-route-command";
import {ShortDto} from "../../../models/short-dto";

const useRouteService = () => {
    const [loading, setLoading] = useState<boolean>(false);

    const handleRequest = async <T>(request: Promise<T>): Promise<T> => {
        setLoading(true);
        try {
            return await request;
        } finally {
            setLoading(false);
        }
    };

    async function createRoute(command: CreateRouteCommand): Promise<RouteDto> {
        return handleRequest(instance.post<RouteDto>('/v1/backoffice/routes', command).then(res => res.data));
    }

    async function updateRoute(id: string, command: UpdateRouteCommand): Promise<RouteDto> {
        return handleRequest(instance.put<RouteDto>(`/v1/backoffice/routes/${id}`, command).then(res => res.data));
    }

    async function deleteRoute(id: string): Promise<void> {
        return handleRequest(instance.delete(`/v1/backoffice/routes/${id}`).then(() => {}));
    }

    async function getRoutes(filter?: RouteFilter): Promise<PagedList<RouteDto>> {
        return handleRequest(instance.get<BaseResponse<PagedList<RouteDto>>>("/v1/backoffice/routes", { params: filter })
            .then(res => res.data.data));
    }

    async function getRouteById(id: string): Promise<RouteDto> {
        return handleRequest(instance.get<BaseResponse<RouteDto>>(`/v1/backoffice/routes/${id}`).then(res => res.data.data));
    }

    // Nova função para obter rotas em formato ShortDto
    async function getShortRoutes(): Promise<ShortDto[]> {
        return handleRequest(instance.get<BaseResponse<ShortDto[]>>("/v1/backoffice/routes/short")
            .then(res => res.data.data));
    }

    return {
        loading,
        createRoute,
        updateRoute,
        deleteRoute,
        getRoutes,
        getRouteById,
        getShortRoutes
    };
};

export default useRouteService; 